'use client';

import { createContext } from 'react';

import type { ProgressRootContextInterface } from '../types/progress-root.types';

export const ProgressRootContext = createContext<ProgressRootContextInterface>({});

ProgressRootContext.displayName = 'Progress.Root.Context';
